(() => {
  'use strict';
  const KEY = 'BosscoCanopyDelivery';
  if (window[KEY]) { window[KEY].scan(); return; }
  let hero, native, observer, timer, request, pickupBinding, requestedVariant = '', failedVariant = '', modeBound = false;
  const text = node => node?.textContent.replace(/\s+/g, ' ').trim() || '';
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const hide = (node, value) => { if (node && node.hidden !== value) node.hidden = value; };
  const visible = node => !!node && !node.closest('[hidden]') && !!node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden';
  const variantId = () => native?.querySelector('.product-purchase-form [name="id"]')?.value || '';
  const mirrorSignatures = new WeakMap();
  function releasePickupBinding() {
    if (!pickupBinding) return;
    const binding = pickupBinding;
    binding.generation++;
    if (binding.runtime.functions.getAvailableStores === binding.guardedGet) {
      binding.runtime.functions.getAvailableStores = binding.originalGet;
    }
    if (binding.runtime.functions.updateContent === binding.guardedUpdate) {
      binding.runtime.functions.updateContent = binding.originalUpdate;
    }
    pickupBinding = null;
  }
  function bindPickupRuntime() {
    const pickup = native?.querySelector('[data-store-availability-container]');
    const instance = window.theme?.Sections?._instances?.find(item => item.target === native);
    const runtime = instance?.thisContext?.storeAvailability;
    if (!pickup || runtime?.$container?.[0] !== pickup || typeof runtime.functions?.getAvailableStores !== 'function' ||
        typeof runtime.functions.updateContent !== 'function') return;
    if (pickupBinding?.runtime === runtime) return;
    releasePickupBinding();
    const binding = { runtime, pickup, native, originalGet: runtime.functions.getAvailableStores,
      originalUpdate: runtime.functions.updateContent, generation: 0, updateDepth: 0, acceptedVariant: '' };
    binding.guardedUpdate = function guardedUpdate(...args) {
      binding.generation++;
      binding.updateDepth++;
      try { return binding.originalUpdate.apply(this, args); }
      finally { binding.updateDepth--; }
    };
    binding.guardedGet = function guardedGet(requestedId, callback) {
      const requested = String(requestedId);
      const currentRequest = binding.generation;
      const replacesContent = binding.updateDepth > 0;
      // A delayed location lookup from a closed popup must not supersede a
      // current selection or refresh distances while its content is loading.
      if (variantId() !== requested || (!replacesContent && pickup.classList.contains('store-availability-loading'))) return;
      // The native widget can finish older requests after a newer selection.
      // Guard only this product's existing instance; keep its transport and UI.
      return binding.originalGet.call(this, requestedId, function (...args) {
        if (pickupBinding !== binding || currentRequest !== binding.generation ||
            native !== binding.native || !pickup.isConnected || variantId() !== requested) return;
        if (replacesContent) binding.runtime.$modal?.remove();
        const result = callback.apply(this, args);
        binding.acceptedVariant = requested;
        pickup.dataset.bcPickupVariant = requested;
        binding.runtime.$modal?.attr('data-bc-pickup-variant', requested);
        schedule();
        return result;
      });
    };
    runtime.functions.updateContent = binding.guardedUpdate;
    runtime.functions.getAvailableStores = binding.guardedGet;
    pickupBinding = binding;
  }
  function mirrorWidget(slot, sources, kind) {
    if (!slot) return;
    const fragments = sources.filter(Boolean).map(source => {
      const copy = source.cloneNode(true);
      const opener = copy.querySelector('[data-store-availability-modal-open]');
      copy.querySelectorAll('script').forEach(node => node.remove());
      // Reuse the existing UI without registering another app instance or modal.
      for (const node of [copy, ...copy.querySelectorAll('*')]) {
        for (const attribute of Array.from(node.attributes)) {
          if ((attribute.name.startsWith('data-') && !['data-status','data-active-variant-id'].includes(attribute.name)) ||
              ['id','aria-controls','aria-expanded','aria-live'].includes(attribute.name)) node.removeAttribute(attribute.name);
        }
      }
      if (copy.getAttribute('role') === 'status') copy.removeAttribute('role');
      if (kind === 'stock') copy.setAttribute('data-bc-restock-widget', '');
      if (opener) {
        opener.setAttribute('data-bc-hero-pickup-open', '');
        opener.setAttribute('aria-haspopup', 'dialog');
      }
      return copy;
    });
    const signature = fragments.map(node => node.outerHTML).join('');
    if (mirrorSignatures.get(slot) !== signature) {
      slot.replaceChildren(...fragments);
      mirrorSignatures.set(slot, signature);
    }
  }
  function syncAvailability() {
    const area = hero?.querySelector('[data-bc-hero-availability]');
    if (!area || !native) return;
    const current = variantId();
    const root = native.querySelector('[data-bossco-restock-date]');
    const currentRestock = visible(root) && root.dataset.activeVariantId === current;
    const low = native.querySelector('.product-low-stock-notice');
    const legacy = native.querySelector('.product-stock-message');
    const stockSources = [];
    if (currentRestock) stockSources.push(root);
    if (visible(low) && !text(root).includes(text(low))) stockSources.push(low);
    if (!stockSources.length && !root?.dataset.activeVariantId && visible(legacy)) stockSources.push(legacy);
    const message = stockSources.map(source => text(source.querySelector('[data-restock-message]') || source)).join(' ');
    const stock = area.querySelector('[data-bc-hero-stock]');
    mirrorWidget(stock, stockSources, 'stock'); hide(stock, !message);
    area.dataset.state = currentRestock ? root.dataset.status : 'default';
    const pickup = native.querySelector('[data-store-availability-container]');
    const selector = hero.querySelector('[data-bc-variant]');
    const selectedTitle = selector?.selectedOptions[0]?.textContent.replace(/ — Sold out$/, '').trim();
    const pickupModal = pickupBinding?.runtime.$modal?.[0];
    const loadedPickupTitle = text((pickupModal || document).querySelector('.store-availabilities-modal__variant-title'));
    const pickupMatchesVariant = (!selector || selector.options.length < 2 || loadedPickupTitle === selectedTitle) &&
      (!pickupBinding?.acceptedVariant || pickup.dataset.bcPickupVariant === current);
    const ready = visible(pickup) && !pickup.classList.contains('store-availability-loading') &&
      pickupMatchesVariant && (!root || root.hidden || (currentRestock && root.dataset.status === 'available'));
    const pickupInfo = ready ? pickup.querySelector('.store-availability-information') : null;
    const pickupText = text(pickupInfo);
    const pickupArea = area.querySelector('[data-bc-hero-pickup]');
    mirrorWidget(pickupArea, [pickupInfo], 'pickup');
    hide(pickupArea, !pickupText);
    const opener = pickup?.querySelector('[data-store-availability-modal-open]');
    hide(area.querySelector('[data-bc-hero-pickup-open]'), !pickupText || !visible(opener));
    hide(area, !message && !pickupText);
    // The purchase status retains cart errors and acts as the no-JS/unavailable-data fallback.
    const status = hero.querySelector('[data-bc-purchase-status]');
    hide(status, !!message && !hero.querySelector('[data-bc-purchase]')?.dataset.bcError);
  }
  function shippingMessage(value) {
    const status = hero?.querySelector('[data-bc-shipping-status]');
    setText(status, value); hide(status, !value);
  }
  function fitShippingWidget(slot) {
    const host = slot?.querySelector('partbot-shipping-calculator');
    const shadow = host?.shadowRoot;
    if (!shadow || shadow.querySelector('[data-bc-shipping-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-bc-shipping-style','');
    style.textContent = `
      :host{display:block;container-type:inline-size}
      input[name="partbot-shipping-calculator-address"]{min-width:0;width:100%;min-height:42px}
      .relative.flex.gap-2.items-stretch>div{min-width:0}
      @container(max-width:280px){
        .relative.flex.gap-2.items-stretch{flex-direction:column}
        .relative.flex.gap-2.items-stretch>button{margin-inline:0;min-height:42px;width:100%}
      }
    `;
    shadow.appendChild(style);
  }
  async function syncShipping() {
    const slot = hero?.querySelector('[data-bc-shipping-app]');
    const current = variantId();
    if (!slot || !slot.querySelector('partbot-shipping-calculator') || !current) return;
    fitShippingWidget(slot);
    if (slot.dataset.bcShippingVariant === current) {
      failedVariant = '';
      if (request) { request.abort(); request = null; requestedVariant = ''; }
      hide(slot, false); slot.removeAttribute('aria-busy'); shippingMessage('');
      return;
    }
    if (requestedVariant === current || failedVariant === current) return;
    request?.abort();
    const controller = new AbortController(); request = controller; requestedVariant = current;
    hide(slot, true); slot.setAttribute('aria-busy', 'true'); shippingMessage('Updating shipping for your selection…');
    try {
      const url = new URL(location.href);
      url.searchParams.set('variant', current);
      url.searchParams.set('section_id', slot.dataset.bcSectionId);
      const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Shipping section unavailable');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = parsed.querySelector('[data-bc-shipping-app]');
      if (!replacement?.querySelector('partbot-shipping-calculator') || replacement.dataset.bcShippingVariant !== current) throw new Error('Shipping selection mismatch');
      if (controller.signal.aborted || !slot.isConnected || variantId() !== current) return;
      // A fresh server-rendered app instance updates captured SKU/price/weight as well as the variant.
      // Never move an upgraded Partbot host: its connectedCallback attaches its shadow root again.
      replacement.querySelectorAll('script').forEach(script => script.remove());
      slot.replaceChildren(...Array.from(replacement.childNodes).map(node => document.importNode(node, true)));
      fitShippingWidget(slot);
      slot.dataset.bcShippingVariant = current;
      hide(slot, false); shippingMessage('');
    } catch (error) {
      if (error.name !== 'AbortError' && !controller.signal.aborted && slot.isConnected) {
        failedVariant = current;
        shippingMessage('The shipping calculator could not update. Reload this page to try again, or calculate shipping at checkout.');
      }
    } finally {
      if (request === controller) { request = null; requestedVariant = ''; slot.removeAttribute('aria-busy'); }
    }
  }
  function sync() { timer = 0; if (hero?.isConnected && native?.isConnected) { bindPickupRuntime(); syncAvailability(); syncShipping(); } }
  function schedule() { if (!timer) timer = setTimeout(sync, 40); }
  function scan() {
    const nextHero = document.querySelector('[data-bc-landing]');
    const productId = nextHero?.querySelector('[data-bc-purchase]')?.dataset.productId;
    const nextNative = Array.from(document.querySelectorAll('[data-section-type="main-product"] .product-form')).find(node => node.dataset.productId === productId)?.closest('[data-section-type="main-product"]');
    if (hero !== nextHero || native !== nextNative) {
      observer?.disconnect(); request?.abort(); request = null; requestedVariant = ''; failedVariant = '';
      releasePickupBinding();
      hero = nextHero; native = nextNative;
      if (hero && native) {
        observer = new MutationObserver(schedule);
        observer.observe(native, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['hidden','style','class','data-status','data-active-variant-id','data-runtime-disabled','value'] });
      }
    }
    if (window.jQuery && !modeBound) {
      modeBound = true;
      window.jQuery(window).on('cc-variant-updated.bcCanopyDelivery', schedule);
      window.jQuery(document).on('ajaxError.bcCanopyDelivery', schedule);
    }
    schedule();
  }
  document.addEventListener('change', event => { if (native?.contains(event.target) || hero?.contains(event.target)) schedule(); });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-bc-hero-pickup-open]');
    if (!button || !hero?.contains(button)) return;
    event.preventDefault();
    const opener = native?.querySelector('[data-store-availability-container] [data-store-availability-modal-open]');
    if (!visible(opener)) { schedule(); return; }
    opener.click();
    const dialog = document.querySelector('#bossco-pickup-dialog[open]');
    const restoreFocus = () => { button.setAttribute('aria-expanded','false'); setTimeout(() => { if (button.isConnected && !button.hidden) button.focus({preventScroll:true}); },0); };
    if (dialog) {
      button.setAttribute('aria-expanded','true'); button.setAttribute('aria-controls',dialog.id);
      dialog.addEventListener('close',restoreFocus,{once:true});
    } else {
      const popup = document.querySelector('.store-availabilities-modal');
      if (popup) {
        button.setAttribute('aria-expanded','true');
        let opened = popup.classList.contains('cc-popup--visible');
        const closeObserver = new MutationObserver(() => {
          const isOpen = popup.classList.contains('cc-popup--visible');
          if (!popup.isConnected || (opened && !isOpen)) { closeObserver.disconnect(); restoreFocus(); }
          opened ||= isOpen;
        });
        closeObserver.observe(popup,{attributes:true,attributeFilter:['class']});
        closeObserver.observe(document.body,{childList:true});
      }
    }
  });
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:section:unload',() => setTimeout(scan,0));
  document.addEventListener('shopify:section:reorder',scan);
  addEventListener('load',scan,{once:true});
  addEventListener('popstate',schedule);
  customElements.whenDefined('partbot-shipping-calculator').then(schedule);
  window[KEY] = {scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',scan,{once:true}); else scan();
})();
